// @flow
import styled, { css } from "styled-components";
import buildColor from "../ColorPalette";

const R = 35;
const CIRC = 2 * Math.PI * R;

const getOffset = (percent: number) => CIRC - (percent * CIRC) / 100;

export const RadialProgress = styled.svg.attrs({
  "data-qa-label": "radialLoader"
})`
  position: relative;
  height: auto;
  max-width: ${({ width }) => width}px;
  ${({ icon }) =>
    !icon
      ? css`
          transform: rotate(-90deg);
        `
      : css`
          & > g {
            transform: translate(32.5%, 32.5%);
          }
        `};
  width: 100%;
`;

const Circle = styled.circle`
  fill: ${buildColor("white", "00")};
  stroke-width: 4;
`;

export const CircleIncomplete = styled(Circle)`
  fill: ${({ backgroundColor }) => backgroundColor};
`;

export const CircleComplete = styled(Circle)`
  stroke: ${({ barColor }) => barColor};
  stroke-dasharray: ${getOffset(0)};
  stroke-dashoffset: ${({ percent }) => getOffset(percent)};
  ${({ withTransition }) =>
    withTransition &&
    css`
      transition: stroke-dashoffset 0.3s linear;
    `};
`;

export const PercentageText = styled.text.attrs({
  "data-qa-label": "radialText"
})`
  fill: ${({ textColor }) => textColor};
  text-anchor: middle;
  font-weight: bold;
  font-size: 1.2em;
`;
